import { refererLogin } from "@/api/api";
import { GetQueryString } from "@/utils/utils";

export const loginWithReferer = async (store, Vue) => {
  let referer = GetQueryString("referer") || localStorage.getItem("referer");
  let ak = GetQueryString("ak");
  const app_id = 53;
  let data = { referer: referer, ak: ak, appid: app_id };
  // 通过ak获取token
  try {
    const res = await refererLogin(data);
    const status = res.data.status;
    if (status === 0) {
      let token = res.data.token;
      localStorage.setItem("u_username", res.data.username);
      localStorage.setItem("yc_token", token);
      store.commit("setToken", token);
    }
  } catch (error) {
    console.log(error);
  }
};



// WEBPACK FOOTER //
// ./src/utils/referer.js